// src/pages/ApiDocPage.tsx
import { Link } from 'react-router-dom';

function ApiDocPage() {
    return (
        <div>
            <h1>Documentación del API de Owlysales.com</h1>
            <ul>
                <li><Link to="/api-core">API Core</Link></li>
                <li><Link to="/api-crm">API CRM</Link></li>
            </ul>
        </div>
    );
}

export default ApiDocPage;
